import React, { createContext, useContext, useState, useCallback } from 'react';
import { defaultReferenceTypes } from './defaultReferenceTypes';
import ApiResource from '../../ApiResource';
import { ReferenceTypes } from '../../my-account/types';
import { StaleAwareContext } from '../useStaleAwareDataContext';

interface ReferenceTypesType extends StaleAwareContext<ReferenceTypes>{}

const ReferenceTypesContext = createContext<ReferenceTypesType | undefined>(undefined);

export const ReferenceTypesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [referenceTypesData, setReferenceTypesData] = useState<ReferenceTypes | null>();
    const [lastLoaded, setLastLoaded] = useState<Date | null>(null);
    const [reloadKey, setReloadKey] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    
    const reload = useCallback(() => {
      setReloadKey(prev => prev + 1);
      setLastLoaded(new Date());
      setIsLoading(true);
    }, []);

    const onRefranceDataReceived = (refranceData: ReferenceTypes) => {
      setIsLoading(false);
    }

  return (
    <ApiResource<ReferenceTypes, ReferenceTypes>
        key={`${reloadKey}`}
        resource={`/members/reference-data/all`} 
        managedDataState={[referenceTypesData, setReferenceTypesData]}
        disableRerenderLoading={true}
        onDataReceived={onRefranceDataReceived}
        defaultData={defaultReferenceTypes}
    >
      {(data) => (
        <ReferenceTypesContext.Provider value={{ data, reload, lastLoaded, isLoading }}>
          {children}
        </ReferenceTypesContext.Provider>
      )}
    </ApiResource>
  );
};

export const useReferenceTypesContext = (): ReferenceTypesType => {
  const context = useContext(ReferenceTypesContext);
  if (!context) {
    throw new Error('useReferenceTypesContext must be used within a ReferenceTypesContext.Provider');
  }

  return context;
};
